import React from "react";
import tarjeta from "../../../imagenes/checkout/payment-options/tarjeta.png";
import tarjeta2x from "../../../imagenes/checkout/payment-options/tarjeta@2x.png";
import TextoLeyPais from "./textoLeyPais";

const CuadroTarjeta = ({
  codigoMoneda,
  idMedioDePago,
  onMedioDePagoChange,
  classes = { contenedorTarjeta: `col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12`},
  children,
}) => {
  return (
    <li className={classes.contenedorTarjeta}>
      <div className="payment-card">
        <div className="md-radio">
          <input
            type="radio"
            id="tarjeta"
            checked={idMedioDePago === "3"}
            name="medioDePago"
            onChange={onMedioDePagoChange}
            value="3"
          />
          <label htmlFor="tarjeta">&nbsp;</label>
        </div>
        <h6>Tarjeta de cr&eacute;dito / d&eacute;bito</h6>
        <div className="icon-container">
          <img
            src={tarjeta}
            alt="Icono de una mano pasando una tarjeta"
            srcSet={tarjeta + " 1x, " + tarjeta2x + " 2x"}
          />
        </div>
        <p className="parrafoEnMedioDePago">
          Pag&aacute; tu viaje de forma rápida, fácil y segura con tarjetas de credito y debito. <br />
        </p>
        {children}
        
        {codigoMoneda !== "PES" && <TextoLeyPais />}
      </div>
    </li>
  );
};

export default CuadroTarjeta;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Pago/cuadroTarjeta.js